import React from "react";
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaShieldAlt,
  FaAward,
  FaCheckCircle,
  FaQuestionCircle,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../assets/images/medrpha_logo.png";

export default function Footer() {

  return (
    <footer className="bg-white text-slate-700 pt-12 pb-8 mt-14 border-t border-red-100 shadow-xs">
      <div className="w-full max-w-[1720px] mx-auto px-4 sm:px-6 lg:px-10 2xl:px-16">
        
        {/* TOP ACCREDITATION & ASSURANCE BANNER */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 pb-8 mb-8 border-b border-red-100">
          <div className="flex items-center gap-3 bg-red-50/60 p-3.5 rounded-2xl border border-red-100">
            <div className="w-10 h-10 rounded-xl bg-red-100 text-red-600 flex items-center justify-center shrink-0 shadow-xs">
              <FaShieldAlt size={18} />
            </div>
            <div>
              <h5 className="text-xs font-black text-slate-900">100% NABL & ISO</h5>
              <p className="text-[11px] font-medium text-slate-500">Certified Partner Labs</p>
            </div>
          </div>

          <div className="flex items-center gap-3 bg-red-50/60 p-3.5 rounded-2xl border border-red-100">
            <div className="w-10 h-10 rounded-xl bg-red-100 text-red-600 flex items-center justify-center shrink-0 shadow-xs">
              <FaAward size={18} />
            </div>
            <div>
              <h5 className="text-xs font-black text-slate-900">Free Home Sample</h5>
              <p className="text-[11px] font-medium text-slate-500">Doorstep Collection</p>
            </div>
          </div>

          <div className="flex items-center gap-3 bg-red-50/60 p-3.5 rounded-2xl border border-red-100">
            <div className="w-10 h-10 rounded-xl bg-red-100 text-red-600 flex items-center justify-center shrink-0 shadow-xs">
              <FaCheckCircle size={18} />
            </div>
            <div>
              <h5 className="text-xs font-black text-slate-900">6-Hour Fast Reports</h5>
              <p className="text-[11px] font-medium text-slate-500">Pathologist Verified</p>
            </div>
          </div>

          <div className="flex items-center gap-3 bg-red-50/60 p-3.5 rounded-2xl border border-red-100">
            <div className="w-10 h-10 rounded-xl bg-red-100 text-red-600 flex items-center justify-center shrink-0 shadow-xs">
              <FaPhone size={16} />
            </div>
            <div>
              <h5 className="text-xs font-black text-slate-900">Medical Support</h5>
              <p className="text-[11px] font-medium text-slate-500">Dial: +91 81783 99885</p>
            </div>
          </div>
        </div>

        {/* MAIN MULTI-COLUMN NAVIGATION */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-8">
          
          {/* BRAND COLUMN */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-block mb-3">
              <img
                src={logo}
                alt="Medrpha Labs"
                className="h-10 md:h-12 object-contain"
              />
            </Link>
            <p className="text-xs leading-relaxed text-slate-600 max-w-sm">
              India's premier digital pathology and diagnostics platform. Precision blood tests, full-body preventive checkups, and verified pathology reports with doorstep sample collection.
            </p>

            <div className="mt-5 flex items-center gap-3 flex-wrap">
              <a
                href="https://wa.me/918178399885"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-bold px-4 py-2.5 rounded-xl transition-all shadow-xs"
              >
                <FaWhatsapp size={14} />
                <span>WhatsApp Us</span>
              </a>
              <a
                href="tel:8178399885"
                className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white text-xs font-bold px-4 py-2.5 rounded-xl transition-all shadow-xs"
              >
                <FaPhone size={12} />
                <span>Book on Call</span>
              </a>
            </div>

            {/* Play Store App Download Link */}
            <div className="mt-5 pt-4 border-t border-red-100">
              <span className="text-[10px] font-bold uppercase tracking-wider text-slate-500 block mb-2">
                Download Official Mobile App
              </span>
              <a
                href="https://play.google.com/store/apps/details?id=com.medrpha_labs.app"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 bg-red-50 hover:bg-red-100 text-red-700 border border-red-200 text-xs font-bold px-4 py-2.5 rounded-xl transition-all shadow-xs"
              >
                <svg className="w-4 h-4 fill-current text-red-600" viewBox="0 0 24 24">
                  <path d="M3.609 1.814L13.792 12 3.61 22.186a1.91 1.91 0 0 1-.22-.924V2.738c0-.34.08-.655.22-.924zm1.474-1.222l11.455 6.613-3.084 3.084L5.083.592zm11.455 16.203L5.083 23.408l8.36-8.36 3.095 3.095v.001l-.001.001-.001.001zM17.43 12.71l2.455-1.417c.806-.466.806-1.22 0-1.686L17.43 8.19 14.88 10.74l2.55 2.55v-.001l.001.001.001.001-.002.001z"/>
                </svg>
                <span>Get on Google Play Store</span>
              </a>
            </div>
          </div>

          {/* POPULAR DIAGNOSTIC TESTS */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-wider text-red-600 mb-3.5">
              Popular Tests
            </h3>
            <ul className="space-y-2.5 text-xs font-medium text-slate-600">
              <li><Link to="/all-tests" className="hover:text-red-600 transition-colors">Complete Hemogram (CBC)</Link></li>
              <li><Link to="/all-tests" className="hover:text-red-600 transition-colors">Thyroid Profile (T3, T4, TSH)</Link></li>
              <li><Link to="/all-tests" className="hover:text-red-600 transition-colors">HbA1c & Fasting Sugar</Link></li>
              <li><Link to="/all-tests" className="hover:text-red-600 transition-colors">Liver Function Test (LFT)</Link></li>
              <li><Link to="/all-tests" className="hover:text-red-600 transition-colors">Kidney Function Test (KFT)</Link></li>
              <li><Link to="/all-tests" className="hover:text-red-600 transition-colors">Vitamin D & B12 Test</Link></li>
            </ul>
          </div>

          {/* HEALTH PACKAGES & SERVICES */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-wider text-red-600 mb-3.5">
              Diagnostic Services
            </h3>
            <ul className="space-y-2.5 text-xs font-medium text-slate-600">
              <li><Link to="/all-packages" className="hover:text-red-600 transition-colors">Comprehensive Health Package</Link></li>
              <li><Link to="/all-packages" className="hover:text-red-600 transition-colors">Senior Citizen Checkup</Link></li>
              <li><Link to="/all-packages" className="hover:text-red-600 transition-colors">Women Wellness Profile</Link></li>
              <li><Link to="/all-packages" className="hover:text-red-600 transition-colors">Cardiac Risk Profile</Link></li>
              <li><Link to="/lab" className="hover:text-red-600 transition-colors">Find Nearby Partner Labs</Link></li>
              <li><Link to="/partner-with-us" className="hover:text-red-600 transition-colors">Franchise & Partner Lab</Link></li>
            </ul>
          </div>

          {/* CORPORATE & POLICIES */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-wider text-red-600 mb-3.5">
              Company & Support
            </h3>
            <ul className="space-y-2.5 text-xs font-medium text-slate-600">
              <li><Link to="/about" className="hover:text-red-600 transition-colors">About Us</Link></li>
              <li><Link to="/services" className="hover:text-red-600 transition-colors">Our Services</Link></li>
              <li>
                <Link to="/faq" className="inline-flex items-center gap-1.5 text-red-600 font-bold hover:underline">
                  <FaQuestionCircle size={12} />
                  <span>FAQs & Helpdesk</span>
                </Link>
              </li>
              <li><Link to="/terms-conditions" className="hover:text-red-600 transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-red-600 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/signin" className="hover:text-red-600 transition-colors">Patient Portal Login</Link></li>
            </ul>

            {/* SOCIAL MEDIA */}
            <div className="flex gap-2.5 mt-5">
              <a
                href="https://www.facebook.com/MedrphaLabTest"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-8 h-8 flex items-center justify-center rounded-xl bg-red-50 hover:bg-red-600 text-red-600 hover:text-white transition-colors border border-red-100"
              >
                <FaFacebook size={14} />
              </a>
              <a
                href="https://www.instagram.com/medrphalab"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-8 h-8 flex items-center justify-center rounded-xl bg-red-50 hover:bg-red-600 text-red-600 hover:text-white transition-colors border border-red-100"
              >
                <FaInstagram size={14} />
              </a>
              <a
                href="https://www.youtube.com/@MedrphaLabTest"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="w-8 h-8 flex items-center justify-center rounded-xl bg-red-50 hover:bg-red-600 text-red-600 hover:text-white transition-colors border border-red-100"
              >
                <FaYoutube size={14} />
              </a>
            </div>
          </div>

        </div>



        {/* BOTTOM COPYRIGHT */}
        <div className="text-center mt-10 border-t border-red-100 pt-6 text-xs text-slate-500 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p>© {new Date().getFullYear()} MedrphaLabs Diagnostics (ARMC PHARMA PVT LTD). All Rights Reserved.</p>
          <p className="text-[11px] font-medium text-slate-500">100% NABL & ISO Accredited Partner Network</p>
        </div>

      </div>
    </footer>
  );
}